/* Ezzy Choice theme scripts. No dependencies. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var n = Math.round(cents / 100);
    return 'Rs ' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* ---------- announcement ---------- */
  $$('[data-ann]').forEach(function (bar) {
    var items = $$('.ann-t p', bar), i = 0, ms = (parseFloat(bar.dataset.speed) || 4) * 1000, timer;
    if (items.length < 2) return;
    function go(n) { items[i].classList.remove('on'); i = (n + items.length) % items.length; items[i].classList.add('on'); }
    function start() { if (!reduce) timer = setInterval(function () { go(i + 1); }, ms); }
    $('.ann-p', bar).onclick = function () { clearInterval(timer); go(i - 1); start(); };
    $('.ann-n', bar).onclick = function () { clearInterval(timer); go(i + 1); start(); };
    start();
  });

  /* ---------- header ---------- */
  var hdr = $('[data-hdr]');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('stuck', window.scrollY > 60); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }
  function toggle(id, open) { var el = $(id); if (!el) return; el.classList.toggle('open', open); el.setAttribute('aria-hidden', open ? 'false' : 'true'); document.body.style.overflow = open ? 'hidden' : ''; }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-open-drawer]')) toggle('#drawer', true);
    else if (t.closest('[data-close-drawer]')) toggle('#drawer', false);
    else if (t.closest('[data-open-search]')) { toggle('#srch', true); var q = $('#srch input[type=search]'); if (q) setTimeout(function () { q.focus(); }, 80); }
    else if (t.closest('[data-close-search]')) toggle('#srch', false);
    else if (t.closest('[data-open-filters]')) { var f = $('#filters'), b = $('.filters-bg'); if (f) f.classList.add('open'); if (b) b.classList.add('open'); }
    else if (t.closest('[data-close-filters]')) { var f2 = $('#filters'), b2 = $('.filters-bg'); if (f2) f2.classList.remove('open'); if (b2) b2.classList.remove('open'); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { toggle('#drawer', false); toggle('#srch', false); } });

  /* ---------- hero ---------- */
  $$('[data-hero]').forEach(function (hero) {
    var slides = $$('.hs', hero), dots = $$('.hero-dots button', hero), i = 0;
    if (slides.length < 2) return;
    function go(n) { slides[i].classList.remove('on'); dots[i] && dots[i].classList.remove('on'); i = (n + slides.length) % slides.length; slides[i].classList.add('on'); dots[i] && dots[i].classList.add('on'); }
    dots.forEach(function (d, n) { d.onclick = function () { go(n); }; });
    var secs = parseFloat(hero.dataset.autoplay);
    if (isNaN(secs)) secs = 6;
    if (!reduce && secs > 0) setInterval(function () { go(i + 1); }, secs * 1000);
  });

  /* ---------- fade in ---------- */
  if ('IntersectionObserver' in window && !reduce) {
    var fio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); fio.unobserve(e.target); } }); }, { threshold: .15 });
    var obs = function (root) { $$('[data-fade]', root).forEach(function (el) { fio.observe(el); }); };
    obs(document);
    document.addEventListener('shopify:section:load', function (e) { obs(e.target); });
  } else { $$('[data-fade]').forEach(function (el) { el.classList.add('in'); }); }

  /* ---------- swipe rows ---------- */
  function rows(root) {
    $$('[data-row]', root).forEach(function (row) {
      if (row._ez) return; row._ez = 1;
      var wrap = row.closest('section') || row.parentNode;
      var step = function () { var first = row.firstElementChild; return first ? first.getBoundingClientRect().width + 20 : row.clientWidth * .8; };
      $$('[data-row-prev]', wrap).forEach(function (b) { b.onclick = function () { row.scrollBy({ left: -step() * 2 }); }; });
      $$('[data-row-next]', wrap).forEach(function (b) { b.onclick = function () { row.scrollBy({ left: step() * 2 }); }; });
      var bar = $('[data-row-bar]', wrap);
      if (bar) { var upd = function () { var max = row.scrollWidth - row.clientWidth; bar.style.width = (max > 0 ? Math.max(12, (row.clientWidth / row.scrollWidth) * 100) : 100) + '%'; bar.style.left = (max > 0 ? (row.scrollLeft / max) * (100 - parseFloat(bar.style.width)) : 0) + '%'; }; row.addEventListener('scroll', upd, { passive: true }); upd(); }
    });
  }
  rows(document);

  /* ---------- reels ---------- */
  $$('[data-reel]').forEach(function (r) {
    var v = $('video', r), mu = $('[data-mute]', r);
    if (!v) return;
    v.muted = true; v.loop = true; v.setAttribute('playsinline', '');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }); }, { threshold: .5 }).observe(r);
    }
    if (mu) mu.onclick = function (e) { e.preventDefault(); e.stopPropagation(); v.muted = !v.muted; mu.innerHTML = v.muted ? '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="m17 9 4 6m0-6-4 6"/></svg>' : '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16.5 8.5a5 5 0 0 1 0 7"/></svg>'; };
  });

  /* ---------- gift unwrap ---------- */
  if ('IntersectionObserver' in window) {
    var gio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { setTimeout(function () { e.target.classList.add('opened'); }, 150); gio.unobserve(e.target); } }); }, { threshold: .4 });
    $$('[data-unwrap]').forEach(function (g) { gio.observe(g); });
  } else { $$('[data-unwrap]').forEach(function (g) { g.classList.add('opened'); }); }

  /* ---------- review slider: keeps scrolling, swipe or drag any time ---------- */
  $$('[data-rvw]').forEach(function (t) {
    if (t.dataset.ready) return; t.dataset.ready = '1';
    var sec = t.closest('section'), pps = (parseFloat(t.dataset.speed) || 0) * 12, items = [].slice.call(t.children), n = items.length;
    if (!n) return;
    function addSet() { items.forEach(function (it) { var c = it.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-block-id'); t.appendChild(c); }); }
    var setW = 0, pos = 0, paused = false, resumeT, last = 0;
    function measure() { setW = t.children[n].offsetLeft - t.children[0].offsetLeft; }
    addSet(); measure();
    var sets = 2; while (setW > 0 && sets < 3 + Math.ceil(t.clientWidth / setW)) { addSet(); sets++; }
    function wrap() { if (!setW) return; if (t.scrollLeft >= setW * 2) { t.scrollLeft -= setW; pos = t.scrollLeft; } else if (t.scrollLeft <= 1) { t.scrollLeft += setW; pos = t.scrollLeft; } }
    function init() { measure(); t.scrollLeft = setW; pos = t.scrollLeft; }
    init(); window.addEventListener('load', init); window.addEventListener('resize', measure);
    function hold() { paused = true; clearTimeout(resumeT); }
    function release() { clearTimeout(resumeT); resumeT = setTimeout(function () { pos = t.scrollLeft; paused = false; }, 1800); }
    ['pointerdown', 'touchstart', 'wheel', 'mouseenter'].forEach(function (ev) { t.addEventListener(ev, hold, { passive: true }); });
    ['pointerup', 'touchend', 'mouseleave'].forEach(function (ev) { t.addEventListener(ev, release, { passive: true }); });
    t.addEventListener('scroll', function () { if (paused) wrap(); }, { passive: true });
    var step = function () { var f = t.firstElementChild; return f ? f.getBoundingClientRect().width + 26 : 240; };
    $('[data-rvw-next]', sec).onclick = function () { hold(); t.scrollBy({ left: step(), behavior: 'smooth' }); release(); };
    $('[data-rvw-prev]', sec).onclick = function () { hold(); t.scrollBy({ left: -step(), behavior: 'smooth' }); release(); };
    if (pps && !reduce) {
      var vis = true;
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; }).observe(t);
      (function tick(ts) {
        if (last && !paused && vis && setW) { pos += pps * Math.min(ts - last, 60) / 1000; t.scrollLeft = pos; wrap(); }
        last = ts; requestAnimationFrame(tick);
      })(0);
    }
  });

  /* ---------- collection ---------- */
  document.addEventListener('click', function (e) { $$('[data-flt][open]').forEach(function (d) { if (!d.contains(e.target) && window.innerWidth > 860) d.removeAttribute('open'); }); });
  $$('[data-auto-submit]').forEach(function (el) { el.addEventListener('change', function () { el.form && el.form.submit(); }); });

  /* ---------- product page ---------- */
  $$('[data-pdp]').forEach(function (pdp) {
    var stage = $('[data-stage]', pdp), media = $$('.gal-m', pdp), thumbs = $$('[data-thumb]', pdp), cur = 0, cnt = $('[data-cur]', pdp);
    function show(n) {
      if (!media.length) return; cur = (n + media.length) % media.length;
      media.forEach(function (m, i) { m.classList.toggle('on', i === cur); });
      thumbs.forEach(function (t, i) { t.classList.toggle('on', i === cur); });
      if (cnt) cnt.textContent = cur + 1;
    }
    thumbs.forEach(function (t, i) { t.onclick = function () { show(i); }; });
    var pv = $('[data-prev]', pdp), nx = $('[data-next]', pdp);
    if (pv) pv.onclick = function () { show(cur - 1); }; if (nx) nx.onclick = function () { show(cur + 1); };
    var sx = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); sx = null; });
    }

    var form = $('#pf', pdp), vJSON = $('[data-variants]', pdp), variants = [];
    try { variants = JSON.parse(vJSON.textContent); } catch (e) {}
    var idIn = $('[data-variant-id]', pdp), priceEl = $('[data-price]', pdp), cmpEl = $('[data-compare]', pdp), saveEl = $('[data-save]', pdp), priceM = $('[data-price-m]', pdp);
    var orderBtn = $('[data-order]', pdp), addBtn = $('[data-add]', pdp), orderT = $('[data-order-t]', pdp), orderM = $('[data-order-m]', pdp), err = $('[data-err]', pdp);
    function selected() { return $$('.opt', pdp).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function pickVariant() {
      var sel = selected(); if (!sel.length) return variants[0];
      return variants.filter(function (v) { return sel.every(function (s, i) { return v.options[i] === s; }); })[0];
    }
    function update() {
      var v = pickVariant(); if (!v) return;
      idIn.value = v.id;
      $$('.opt', pdp).forEach(function (fs) { var c = $('input:checked', fs), l = $('[data-opt-val]', fs); if (c && l) l.textContent = c.value; });
      priceEl.textContent = money(v.price); if (priceM) priceM.textContent = money(v.price);
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      if (cmpEl) { cmpEl.hidden = !sale; cmpEl.textContent = sale ? money(v.compare_at_price) : ''; }
      if (saveEl) { saveEl.hidden = !sale; saveEl.textContent = sale ? 'Save ' + money(v.compare_at_price - v.price) : ''; }
      [orderBtn, addBtn, orderM].forEach(function (b) { if (b) b.disabled = !v.available; });
      if (orderT) orderT.textContent = v.available ? 'Order now · Cash on delivery' : 'Sold out';
      if (v.featured_media && v.featured_media.id) { var idx = media.findIndex(function (m) { return m.dataset.media == v.featured_media.id; }); if (idx > -1) show(idx); }
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
    }
    $$('.opt input', pdp).forEach(function (i) { i.addEventListener('change', update); });
    $$('[data-q]', pdp).forEach(function (b) { b.onclick = function () { var i = b.parentNode.querySelector('input'); i.value = Math.min(10, Math.max(1, (+i.value || 1) + (+b.dataset.q))); }; });

    function add(goCheckout) {
      err.hidden = true;
      var items = [{ id: +idIn.value, quantity: +($('[name=quantity]', pdp).value) || 1 }];
      var g = $('[data-gift]', pdp);
      if (g && g.checked) items.push({ id: +g.dataset.giftId, quantity: 1 });
      [orderBtn, addBtn, orderM].forEach(function (b) { if (b) b.disabled = true; });
      post(EZ.routes.add + '.js', { items: items }).then(function () {
        if (goCheckout) { location.href = '/checkout'; return; }
        return fetch(EZ.routes.cartjs).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); toast('Added to your bag'); });
      }).catch(function (e) { err.textContent = (e && (e.description || e.message)) || 'Could not add this item. Please try again.'; err.hidden = false; })
        .then(function () { var v = pickVariant(); [orderBtn, addBtn, orderM].forEach(function (b) { if (b) b.disabled = !(v && v.available); }); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(true); });
    if (addBtn) addBtn.onclick = function () { add(false); };
    if (orderM) orderM.onclick = function () { add(true); };

    var mbar = $('[data-mbar]', pdp);
    if (mbar && 'IntersectionObserver' in window && orderBtn) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { mbar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); }); }).observe(orderBtn);
    }

    var rel = $('[data-related]');
    if (rel && rel.dataset.url) {
      fetch(rel.dataset.url).then(function (r) { return r.text(); }).then(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html'), n = d.querySelector('[data-related]');
        if (n && n.innerHTML.trim()) { rel.innerHTML = n.innerHTML; rows(rel); }
      }).catch(function () {});
    }
  });

  /* ---------- cart ---------- */
  $$('[data-cart]').forEach(function (cart) {
    function change(line, qty) { return post(EZ.routes.change + '.js', { line: line, quantity: qty }).then(function () { location.reload(); }); }
    $$('.qty', cart).forEach(function (q) {
      var inp = $('input', q), line = +inp.dataset.line;
      $$('button', q).forEach(function (b) { b.onclick = function () { change(line, Math.max(0, (+inp.value || 0) + (+b.dataset.d))); }; });
      inp.onchange = function () { change(line, Math.max(0, +inp.value || 0)); };
    });
  });

  /* ---------- track order ---------- */
  $$('[data-track]').forEach(function (root) {
    var form = $('[data-track-form]', root), out = $('[data-track-out]', root), nf = $('[data-track-nf]', root), wrap = $('.tk', root);
    var endpoint = root.dataset.endpoint, STEPS = ['Booked', 'Picked up', 'In transit', 'Out for delivery', 'Delivered'];
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function fmt(t) { var d = new Date(t); if (isNaN(d)) return esc(t || ''); return d.toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }); }
    function render(o) {
      nf.hidden = true; wrap.classList.add('has');
      var st = Math.min(Math.max(+o.stage || 0, 0), 4), hist = o.history || [];
      var days = o.days != null ? o.days : (o.booked_at ? Math.max(0, Math.round((Date.now() - new Date(o.booked_at)) / 864e5)) : 0);
      out.innerHTML = '<div class="res"><div class="rh"><div><small>Tracking number</small><h2>' + esc(o.tracking_number) + '<button type="button" data-copy>Copy</button></h2></div><div class="chs"><span class="st">' + esc(o.status || STEPS[st]) + '</span>' + (o.origin || o.destination ? '<span>' + esc(o.origin || '') + ' → ' + esc(o.destination || '') + '</span>' : '') + '</div></div>' +
        '<div class="inf3"><div><small>Booked</small><b>' + fmt(o.booked_at) + '</b></div><div><small>Cash on delivery</small><b>' + (o.cod_amount != null ? 'Rs ' + Number(o.cod_amount).toLocaleString('en-US') : '-') + '</b></div><div><small>' + (st >= 4 ? 'Delivered in' : 'In transit for') + '</small><b>' + days + ' day' + (days === 1 ? '' : 's') + '</b></div></div>' +
        '<div class="pb">' + STEPS.map(function (s, i) { return '<div class="' + (i <= st ? 'd' : '') + (i === st ? ' c' : '') + '"><i>' + (i <= st ? '✓' : i + 1) + '</i>' + s + '</div>'; }).join('') + '</div>' +
        (hist.length ? '<div class="hh">Tracking history</div><div class="hl2">' + hist.map(function (h, i) { return '<div class="he"><i></i><div><b>' + esc(h.title) + (i === 0 ? '<span class="lt">Latest</span>' : '') + '</b><p>' + esc(h.location || '') + '</p></div><em>' + fmt(h.time) + '</em></div>'; }).join('') + '</div>' : '') +
        '<div class="rf"><span>Updated ' + (o.updated_at ? fmt(o.updated_at) : 'just now') + ' (auto every 15 min)</span>' + (o.tracking_url ? '<a href="' + esc(o.tracking_url) + '" target="_blank" rel="noopener">Open on Leopards</a>' : '') + '</div></div>';
      var cp = $('[data-copy]', out); if (cp) cp.onclick = function () { try { navigator.clipboard.writeText(o.tracking_number); } catch (e) {} cp.textContent = 'Copied'; setTimeout(function () { cp.textContent = 'Copy'; }, 1500); };
    }
    function notFound() { wrap.classList.remove('has'); out.innerHTML = ''; nf.hidden = false; }
    function demo() {
      var now = Date.now();
      return { tracking_number: 'LE7342915680', status: 'In transit', stage: 2, origin: 'Lahore', destination: 'Karachi', booked_at: new Date(now - 2 * 864e5).toISOString(), cod_amount: 5998, tracking_url: 'https://www.leopardscourier.com/',
        history: [{ title: 'Departed to destination city', location: 'Lahore Hub', time: new Date(now - 3600e3 * 5).toISOString() }, { title: 'Arrived at sorting hub', location: 'Lahore Hub', time: new Date(now - 3600e3 * 12).toISOString() }, { title: 'Picked up by Leopards rider', location: 'Lahore Hub', time: new Date(now - 3600e3 * 30).toISOString() }, { title: 'Shipment booked', location: 'Ezzy Choice, Lahore', time: new Date(now - 864e5 * 2).toISOString() }] };
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var o = form.order.value.trim(), p = form.phone.value.replace(/[\s-]/g, '');
      if (!o || !p) return;
      if (!endpoint) { if (root.dataset.demo === 'true' && o.toUpperCase() === 'EC-10482') return render(demo()); return notFound(); }
      var btn = $('button[type=submit]', form); btn.disabled = true;
      fetch(endpoint + (endpoint.indexOf('?') > -1 ? '&' : '?') + 'order=' + encodeURIComponent(o) + '&phone=' + encodeURIComponent(p), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (j && (j.found === undefined || j.found) && j.tracking_number) render(j); else notFound(); })
        .catch(notFound).then(function () { btn.disabled = false; });
    });
    var dl = $('[data-track-demo]', root); if (dl) dl.onclick = function (e) { e.preventDefault(); form.order.value = 'EC-10482'; form.phone.value = '03001234567'; render(demo()); };
    var q = new URLSearchParams(location.search); if (q.get('order') && q.get('phone')) { form.order.value = q.get('order'); form.phone.value = q.get('phone'); form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); }
  });


  /* shrink long product names to stay on one line (phones) */
  function fitTitles(root) {
    $$('.pc-t', root || document).forEach(function (t) {
      var a = t.firstElementChild || t; a.style.fontSize = '';
      var size = parseFloat(getComputedStyle(a).fontSize);
      while (a.scrollWidth > t.clientWidth + 1 && size > 10.5) { size -= 0.5; a.style.fontSize = size + 'px'; }
    });
  }
  fitTitles(); window.addEventListener('load', function () { fitTitles(); }); window.addEventListener('resize', function () { fitTitles(); });

  /* theme editor: re-run row wiring when sections reload */
  document.addEventListener('shopify:section:load', function (e) { rows(e.target); fitTitles(e.target); });
})();
